"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @messaging/server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class RoomApi extends runtime.BaseAPI {
    /**
     */
    createMessageRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling createMessage.');
            }
            if (requestParameters.requestBaseCreateMessagePayload === null || requestParameters.requestBaseCreateMessagePayload === undefined) {
                throw new runtime.RequiredError('requestBaseCreateMessagePayload', 'Required parameter requestParameters.requestBaseCreateMessagePayload was null or undefined when calling createMessage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}/messages`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseCreateMessagePayloadToJSON(requestParameters.requestBaseCreateMessagePayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.MessageFromJSON(jsonValue));
        });
    }
    /**
     */
    createMessage(roomId, requestBaseCreateMessagePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createMessageRaw({ roomId: roomId, requestBaseCreateMessagePayload: requestBaseCreateMessagePayload });
            return yield response.value();
        });
    }
    /**
     */
    deleteRoomMessagesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling deleteRoomMessages.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}/messages`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    deleteRoomMessages(roomId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteRoomMessagesRaw({ roomId: roomId });
        });
    }
    /**
     */
    getMessageRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling getMessage.');
            }
            if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
                throw new runtime.RequiredError('messageId', 'Required parameter requestParameters.messageId was null or undefined when calling getMessage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}/messages/{messageId}`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))).replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.MessageFromJSON(jsonValue));
        });
    }
    /**
     */
    getMessage(roomId, messageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMessageRaw({ roomId: roomId, messageId: messageId });
            return yield response.value();
        });
    }
    /**
     */
    getRoomMessagesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling getRoomMessages.');
            }
            const queryParameters = {};
            if (requestParameters.startAt !== undefined) {
                queryParameters['startAt'] = requestParameters.startAt;
            }
            if (requestParameters.endAt !== undefined) {
                queryParameters['endAt'] = requestParameters.endAt;
            }
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}/messages`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.MessageFromJSON));
        });
    }
    /**
     */
    getRoomMessages(roomId, startAt, endAt, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRoomMessagesRaw({ roomId: roomId, startAt: startAt, endAt: endAt, limit: limit });
            return yield response.value();
        });
    }
    /**
     */
    getRoomMessagesDeprecatedRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling getRoomMessagesDeprecated.');
            }
            const queryParameters = {};
            if (requestParameters.startAt !== undefined) {
                queryParameters['startAt'] = requestParameters.startAt;
            }
            if (requestParameters.endAt !== undefined) {
                queryParameters['endAt'] = requestParameters.endAt;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.MessageFromJSON));
        });
    }
    /**
     */
    getRoomMessagesDeprecated(roomId, startAt, endAt) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRoomMessagesDeprecatedRaw({ roomId: roomId, startAt: startAt, endAt: endAt });
            return yield response.value();
        });
    }
    /**
     */
    markDeletedMessageRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling markDeletedMessage.');
            }
            if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
                throw new runtime.RequiredError('messageId', 'Required parameter requestParameters.messageId was null or undefined when calling markDeletedMessage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}/messages/{messageId}/markDeleted`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))).replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestWithMetaToJSON(requestParameters.requestWithMeta),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    markDeletedMessage(roomId, messageId, requestWithMeta) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.markDeletedMessageRaw({ roomId: roomId, messageId: messageId, requestWithMeta: requestWithMeta });
        });
    }
    /**
     */
    markHiddenMessageRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling markHiddenMessage.');
            }
            if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
                throw new runtime.RequiredError('messageId', 'Required parameter requestParameters.messageId was null or undefined when calling markHiddenMessage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}/messages/{messageId}/markHidden`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))).replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestWithMetaToJSON(requestParameters.requestWithMeta),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    markHiddenMessage(roomId, messageId, requestWithMeta) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.markHiddenMessageRaw({ roomId: roomId, messageId: messageId, requestWithMeta: requestWithMeta });
        });
    }
    /**
     */
    markSawMessageRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling markSawMessage.');
            }
            if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
                throw new runtime.RequiredError('messageId', 'Required parameter requestParameters.messageId was null or undefined when calling markSawMessage.');
            }
            if (requestParameters.requestBaseSeeMessagePayload === null || requestParameters.requestBaseSeeMessagePayload === undefined) {
                throw new runtime.RequiredError('requestBaseSeeMessagePayload', 'Required parameter requestParameters.requestBaseSeeMessagePayload was null or undefined when calling markSawMessage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}/messages/{messageId}/saw`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))).replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseSeeMessagePayloadToJSON(requestParameters.requestBaseSeeMessagePayload),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    markSawMessage(roomId, messageId, requestBaseSeeMessagePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.markSawMessageRaw({ roomId: roomId, messageId: messageId, requestBaseSeeMessagePayload: requestBaseSeeMessagePayload });
        });
    }
    /**
     */
    physicalDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling physicalDelete.');
            }
            if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
                throw new runtime.RequiredError('messageId', 'Required parameter requestParameters.messageId was null or undefined when calling physicalDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}/messages/{messageId}`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))).replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestWithMetaToJSON(requestParameters.requestWithMeta),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    physicalDelete(roomId, messageId, requestWithMeta) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.physicalDeleteRaw({ roomId: roomId, messageId: messageId, requestWithMeta: requestWithMeta });
        });
    }
    /**
     */
    typingRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling typing.');
            }
            if (requestParameters.requestBaseTypingMessagePayload === null || requestParameters.requestBaseTypingMessagePayload === undefined) {
                throw new runtime.RequiredError('requestBaseTypingMessagePayload', 'Required parameter requestParameters.requestBaseTypingMessagePayload was null or undefined when calling typing.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}/typing`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseTypingMessagePayloadToJSON(requestParameters.requestBaseTypingMessagePayload),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    typing(roomId, requestBaseTypingMessagePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.typingRaw({ roomId: roomId, requestBaseTypingMessagePayload: requestBaseTypingMessagePayload });
        });
    }
    /**
     */
    updateMessagePayloadRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling updateMessagePayload.');
            }
            if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
                throw new runtime.RequiredError('messageId', 'Required parameter requestParameters.messageId was null or undefined when calling updateMessagePayload.');
            }
            if (requestParameters.requestBaseUpdateMessagePayload === null || requestParameters.requestBaseUpdateMessagePayload === undefined) {
                throw new runtime.RequiredError('requestBaseUpdateMessagePayload', 'Required parameter requestParameters.requestBaseUpdateMessagePayload was null or undefined when calling updateMessagePayload.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}/messages/{messageId}`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))).replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseUpdateMessagePayloadToJSON(requestParameters.requestBaseUpdateMessagePayload),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    updateMessagePayload(roomId, messageId, requestBaseUpdateMessagePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateMessagePayloadRaw({ roomId: roomId, messageId: messageId, requestBaseUpdateMessagePayload: requestBaseUpdateMessagePayload });
        });
    }
    /**
     */
    upsertMessageRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling upsertMessage.');
            }
            if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
                throw new runtime.RequiredError('messageId', 'Required parameter requestParameters.messageId was null or undefined when calling upsertMessage.');
            }
            if (requestParameters.requestBaseMessage === null || requestParameters.requestBaseMessage === undefined) {
                throw new runtime.RequiredError('requestBaseMessage', 'Required parameter requestParameters.requestBaseMessage was null or undefined when calling upsertMessage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/room/{roomId}/messages/{messageId}`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))).replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseMessageToJSON(requestParameters.requestBaseMessage),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    upsertMessage(roomId, messageId, requestBaseMessage) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.upsertMessageRaw({ roomId: roomId, messageId: messageId, requestBaseMessage: requestBaseMessage });
        });
    }
}
exports.RoomApi = RoomApi;
